import React, { useEffect, useRef, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Copy, Megaphone, RefreshCw } from 'lucide-react';
import { axios, auth, mbUrl, muted, primary, runCall, toast, copyText } from './mbApi';

const FIXER = [
  [/Invite link Telegram belum ready/, 'Azrai: buka "Maklumat teknikal: invite Telegram" di bawah → Generate Invite Link'],
  [/MOCK/, 'Manager: sambung bot Telegram live (tab Tetapan)'],
  [/Landing Page/, 'Manager: isi URL Landing Page dalam tab Tetapan'],
  [/CRM_PUBLIC_ORIGIN/, 'Manager: isi CRM public origin dalam tab Tetapan'],
  [/diarkibkan/, 'Manager: pulihkan ujian dari arkib, atau buat Ujian Baru'],
  [/Mock mode/, 'Manager: tukar Telegram ke mode live sebelum guna dalam iklan sebenar'],
];
const fixerOf = (r) => FIXER.find(([re]) => re.test(r))?.[1];

const ManualCopy = ({ t, url }) => (
  <div className="space-y-1" data-testid={`mb-adurl-manual-${t.id}`}>
    <p className="text-amber-400">Salin automatik gagal (browser tak benarkan). Tekan kotak di bawah, pilih semua, dan salin manual:</p>
    <input readOnly value={url} onFocus={(e) => e.target.select()} className="w-full font-mono text-[11px] rounded border border-[hsl(var(--border))] bg-transparent px-2 py-1"
      data-testid={`mb-adurl-manual-input-${t.id}`} />
  </div>
);

export const AdUrlPanel = ({ ibId, t }) => {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const [copyFailed, setCopyFailed] = useState(false);
  const prepare = () => runCall(setBusy, async () => {
    setCopyFailed(false);
    setData((await axios.post(mbUrl(ibId, `/tests/${t.id}/prepare-ad-url`), {}, auth())).data);
  });
  const opened = useRef(false);
  useEffect(() => {
    if (opened.current) prepare();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t.invite_status, t.invite_link, t.archived]);
  if (data) opened.current = true;
  const ready = data?.copy_allowed && !!data?.ad_url;
  const copy = async () => {
    if (!ready) return;
    if (await copyText(data.ad_url)) { setCopyFailed(false); toast.success('URL Iklan berjaya disalin'); return; }
    setCopyFailed(true);
    toast.error('Gagal salin URL Iklan — salin manual dari kotak');
  };

  if (!data) {
    return (
      <Button size="sm" variant="outline" className="h-9 text-[11px]" disabled={busy} onClick={prepare} data-testid={`mb-adurl-prepare-${t.id}`}>
        <Megaphone size={11} className="mr-1" /> Sedia URL Iklan
      </Button>
    );
  }
  return (
    <div className="rounded border border-[hsl(var(--border))] p-2 space-y-1" data-testid={`mb-adurl-panel-${t.id}`}>
      <p className={primary}>URL Iklan (destinasi iklan Meta = LP + token):</p>
      <p className={`font-mono text-sm break-all ${ready ? primary : 'text-amber-400'}`} data-testid={`mb-adurl-value-${t.id}`}>
        {ready ? data.ad_url : !data.ad_url ? '— set URL LP dulu dalam tetapan' : 'Belum boleh digunakan — selesaikan perkara di bawah dulu'}
      </p>
      <Button size="sm" className="h-10" disabled={!ready} onClick={copy} data-testid={`mb-adurl-copy-${t.id}`}>
        <Copy size={14} className="mr-1.5" /> Salin URL Iklan
      </Button>
      <Button size="sm" variant="ghost" className="h-9 text-[11px] ml-1" disabled={busy} onClick={prepare} data-testid={`mb-adurl-refresh-${t.id}`}>
        <RefreshCw size={10} className="mr-1" /> Semak semula
      </Button>
      {ready && copyFailed && <ManualCopy t={t} url={data.ad_url} />}
      {data.reasons.length > 0 && (
        <ul className="text-amber-400 list-disc pl-4" data-testid={`mb-adurl-reasons-${t.id}`}>
          {data.reasons.map((r) => <li key={r}>{r}{fixerOf(r) && <span className={`block ${muted}`}>→ {fixerOf(r)}</span>}</li>)}
        </ul>
      )}
      <p className={muted}>Ad ID tak perlu untuk URL ni — padankan Ad ID (Match) selepas iklan dicipta di Meta. Ad Account ID (act_…) ≠ Ad ID (nombor satu iklan).</p>
      <p className={`${muted} break-all`}>Butang join di LP kena link ke: <span className="font-mono" data-testid={`mb-adurl-redirect-${t.id}`}>{data.redirect_url || '— CRM_PUBLIC_ORIGIN belum diset'}</span></p>
    </div>
  );
};
